/**
 * Get the parameters.
 * @param  {string} blockId the block id.
 */
export const getParams = (block) => {
	const urlParams = new URLSearchParams(window.location.search);
	const filterContainer = block.querySelector('.em-filterable-content__filter-container');
	const params = {};

	urlParams.forEach((value, key) => {
		params[key] = value;
	});

	// Set default parameters from the block filter container.
	const defaultParams = {
		block: block.id,
		post_type: filterContainer.getAttribute('data-post-types'),
		orderby: filterContainer.getAttribute('data-orderby'),
		order: filterContainer.getAttribute('data-order'),
		paged: filterContainer.getAttribute('data-page'),
		pagination: filterContainer.getAttribute('data-pagination'),
		relation: filterContainer.getAttribute('data-relation'),
	};

	Object.keys(defaultParams).forEach((key) => {
		const value = defaultParams[key];
		if (params[key] !== value) {
			params[key] = value;
		} else {
			params[key] = defaultParams[key];
		}
	});

	return params;
};

export const setParams = (block) => {
	const inputs = block.querySelectorAll('[type="checkbox"], [name="search"]');
	const params = {};

	// Loop through the inputs and get the set values.
	inputs.forEach((e) => {
		const tax = e.getAttribute('data');

		// If is checked set the tax parameters.
		if (e.checked) {
			if (params[tax] !== undefined) {
				params[tax].push(e.value);
			} else {
				params[tax] = [e.value];
			}
		}

		// If is search set the search parameter.
		if (e.classList.contains('filter-search')) {
			if (e.value) {
				params.search = e.value;
			}
		}
	});

	const query = new URLSearchParams(params).toString();
	let newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
	if (query) {
		newUrl += `?${query}`;
	}
	window.history.pushState({ path: newUrl }, '', newUrl);
};
